import { render, staticRenderFns } from "./OrganismExecutiveDashboard.vue?vue&type=template&id=6a1e4bec&scoped=true&"
import script from "./OrganismExecutiveDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganismExecutiveDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganismExecutiveDashboard.vue?vue&type=style&index=0&id=6a1e4bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e4bec",
  null
  
)

export default component.exports